(()=>{'use strict';
const one=(sel,root=document)=>root.querySelector(sel),all=(sel,root=document)=>Array.from(root.querySelectorAll(sel));
function updateClocks(){
 for(const clock of all('[data-countdown]')){
  const target=Date.parse(clock.dataset.countdown),left=Math.max(0,Number.isFinite(target)?target-Date.now():0),n=Math.floor(left/1000);
  const values={days:Math.floor(n/86400),hours:Math.floor(n/3600)%24,minutes:Math.floor(n/60)%60,seconds:n%60};
  for(const [part,value]of Object.entries(values)){const span=one('[data-'+part+']',clock);if(span)span.textContent=String(value).padStart(2,'0')}
 }
}
updateClocks();
if(document.querySelector('[data-countdown]'))window.setInterval(updateClocks,1000);
for(const stage of all('[data-spin-viewer]')){
 const urls=(stage.dataset.frames||'').split('|').map(s=>s.trim()).filter(Boolean);
 const img=one('[data-spin-image]',stage),counter=one('[data-spin-counter]',stage),wrap=stage.parentElement;
 const hint=one('[data-spin-hint]',stage);
 const angles=['FRONT','LEFT SIDE','BACK','RIGHT SIDE'];
 if(!img||!wrap||urls.length<2)continue;
 const buttons=all('[data-spin-to]',wrap);
 const count=urls.length;
 const preloads=urls.map(url=>({url,ready:false,promise:null}));
 let index=0,targetIndex=0,request=0,pointerStart=null,dragging=false;
 stage.dataset.spinReady='false';
 const announce=(message)=>{if(hint)hint.textContent=message};
 const paintButtons=()=>buttons.forEach(b=>{const active=Number(b.dataset.spinTo)===index;b.classList.toggle('is-current',active);b.setAttribute('aria-pressed',String(active))});
 function preload(i){
  const item=preloads[i];
  if(!item)return Promise.reject(Error('Missing image'));
  if(item.ready)return Promise.resolve(item.url);
  if(item.promise)return item.promise;
  item.promise=new Promise((resolve,reject)=>{
   const test=new Image();test.decoding='async';
   test.onload=()=>{const done=()=>{item.ready=true;resolve(item.url)};
      if(typeof test.decode==='function')test.decode().then(done,done);else done()};
   test.onerror=()=>reject(Error('Failed to load angle '+i));
   test.src=item.url;
   if(test.complete&&test.naturalWidth>0){item.ready=true;resolve(item.url)}
  }).catch(e=>{item.promise=null;throw e});
  return item.promise;
 }
 function apply(i,url){
  const changing=(index!==i);
  index=i;img.src=url;img.alt=angles[i]+' concept view of product';
  if(changing&&typeof img.animate==='function'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    img.animate([{opacity:.65,transform:'scale(.988)'},{opacity:1,transform:'scale(1)'}],{duration:185,easing:'ease-out'});
  }
  if(counter)counter.textContent=String(i+1).padStart(2,'0')+' / '+String(count).padStart(2,'0');
  paintButtons();stage.dataset.spinReady='true';stage.removeAttribute('aria-busy');announce('↔ DRAG TO INSPECT');
 }
 function goTo(i){
  targetIndex=(i+count)%count;const next=targetIndex,ticket=++request;
  stage.setAttribute('aria-busy','true');announce('LOADING '+angles[next]+' VIEW...');
  preload(next).then(url=>{if(ticket!==request)return;apply(next,url)},()=>{
    if(ticket!==request)return;
    stage.removeAttribute('aria-busy');announce('ANGLE TEMPORARILY UNAVAILABLE');
    targetIndex=index;
  });
 }
 if(img.complete&&img.naturalWidth>0){preloads[0].ready=true}
 // Render the first view immediately while other angles are prepared in the background.
 index=0;targetIndex=0;paintButtons();
 if(counter)counter.textContent='01 / '+String(count).padStart(2,'0');
 if(hint)hint.textContent='↔ DRAG TO INSPECT';
 stage.dataset.spinReady='true';
 const warm=()=>{if(navigator.connection&&navigator.connection.saveData)return;for(let i=1;i<count;i++)preload(i).catch(()=>{})};
 if(typeof window.requestIdleCallback==='function')window.requestIdleCallback(warm,{timeout:1500});else window.setTimeout(warm,250);
 buttons.forEach(b=>b.addEventListener('click',()=>goTo(Number(b.dataset.spinTo))));
 one('[data-spin-prev]',wrap)?.addEventListener('click',()=>goTo(targetIndex-1));
 one('[data-spin-next]',wrap)?.addEventListener('click',()=>goTo(targetIndex+1));
 stage.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;dragging=true;pointerStart=e.clientX;try{stage.setPointerCapture(e.pointerId)}catch(_){}});
 stage.addEventListener('pointermove',e=>{if(!dragging||pointerStart===null)return;const delta=e.clientX-pointerStart;if(Math.abs(delta)>35){goTo(targetIndex+(delta<0?1:-1));pointerStart=e.clientX}});
 const end=()=>{dragging=false;pointerStart=null};
 stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);stage.addEventListener('lostpointercapture',end);
 stage.addEventListener('keydown',e=>{
  if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();goTo(targetIndex+(e.key==='ArrowRight'?1:-1))}
  if(e.key==='Home'){e.preventDefault();goTo(0)}
  if(e.key==='End'){e.preventDefault();goTo(count-1)}
 });
}
})();